import React, { useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import Button from '@/components/common/Button';
import Api from '@/api';
import AddressFormInfo from './AddressFormInfo';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import { TRIGGERS } from '@/api/global';
import MainIcons from '@/icons/main';

export default function AddressModal({ data, setData, modalKey, type = 'add' }) {
  const { trigger, setTrigger, userInfo, setUserInfo, showError } = useLayoutContext();
  const [loading, setLoading] = useState(false);
  const tCommon = useTranslations('common');
  const [info, setInfo] = useState({
    title: '',
    addressLine1: '',
    addressLine2: '',
    city: null,
    postalCode: '',
    country: null,
    province: null,
    isDefault: false,
    details: '',
    lat: '',
    long: '',
    notes: '',
    error: {
      title: false,
      addressLine1: false,
      city: false,
      postalCode: false,
      country: false,
    },
    messages: {
      title: tCommon('requiredField'),
      addressLine1: tCommon('requiredField'),
      city: tCommon('requiredField'),
      postalCode: tCommon('requiredField'),
      country: tCommon('requiredField'),
    },
  });
  useEffect(() => {
    if (data) {
      setInfo({
        ...info,
        ...data,
      });
    }
  }, [data]);
  console.log('users==', data?.users, data, info);
  const handleSubmit = () => {
    let check = checkError();
    console.log('check==', check);
    if (!check) {
      const params = {
        title: info?.title,
        addressLine1: info?.addressLine1,
        addressLine2: info?.addressLine2,
        cityId: info?.city?.id ? info?.city?.id : undefined,
        postalCode: info?.postalCode ? info?.postalCode : undefined,
        countryId: info?.country?.id ? info?.country?.id : undefined,
        provinceId: info?.province?.id ? info?.province?.id : undefined,
        isDefault: info?.isDefault,
        lat: info?.lat ? info?.lat : undefined,
        lon: info?.long ? info?.long : undefined,
        notes: info?.notes,
      };

      // if (data) {
      //   params.id = info?.id;
      // }
      let apiCall = data ? Api.editAddress(data?.id, params) : Api.addAddress(params);
      setLoading(true);
      apiCall
        .then((res) => {
          setData(undefined);
          setTrigger(TRIGGERS.RERENDER);
          setLoading(false);
          if (!data) {
            setUserInfo({ ...userInfo, addresses: Number(userInfo?.addresses) + 1 });
          }
        })
        .catch((err) => {
          setLoading(false);
          showError(err);
        });
      // setData({ type: type, data: info });
      // setTrigger('');
    }
  };
  const checkError = () => {
    let dummy = { ...info };
    let result = false;
    let array = [];
    let values = ['title', 'addressLine1'];

    values?.map((item, i) => {
      if (String(info?.[item])?.trim()?.length == 0) {
        dummy.error[item] = true;
        result = true;
      }
    });
    array?.map((item, i) => {
      if (info?.[item]?.length == 0) {
        dummy.error[item] = true;
        result = true;
      }
    });
    setInfo({ ...dummy });
    return result;
  };
  console.log('data==', data);
  return (
    <div className={`${styles.container} ${styles.addressFormContainer}`}>
      <AddressFormInfo info={info} setInfo={setInfo} modalKey={modalKey} />
      <div className={`${styles.addressButtonsContainer}`}>
        <Button
          onClick={() => handleSubmit()}
          wrapperStyle={`${styles.saveButton}`}
          className={`btn btn-primary squareButton w-full`}
          loading={loading}
          showAnimation={false}
        >
          <MainIcons.CheckedIcon fill="var(--paper)" width={'18px'} height={'18px'} />
          ذخیره تغییرات
        </Button>
        <Button
          className={`btn btn-white squareButton ${styles.cancelButton}`}
          onClick={() => {
            setData(undefined);
            setTrigger(TRIGGERS.EMPTY);
          }}
        >
          انصراف
        </Button>
      </div>
    </div>
  );
}
